






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PageFooter extends Vue {
  @Prop() readonly doc!: any;
}
